import { ArrowsLeftRightIcon, CardsThreeIcon, UsersIcon, WalletIcon } from "@phosphor-icons/react";
import StatsCard from "components/ui/StatsCard";
import SidebarLayout from "components/Layout/Layout";
import { useData } from "components/provider/data";
import ActiveTradingAccountList from "pages/Dasboard/MainDashBoard/component/AccountTable";

const TradingAccountMainPage = () => {
    const { activeUsers, allAccountBalance, total_trade, totalAccounts } = useData();

    return (
        <SidebarLayout>
            <div className="space-y-6">
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                    <StatsCard
                        title="Total Accounts"
                        icon={<CardsThreeIcon size={20} color="#fff" />}
                        value={totalAccounts}
                        iconBg="#d97706"
                    />
                    <StatsCard
                        title="Active Users"
                        icon={<UsersIcon size={20} color="#fff" />}
                        value={activeUsers}
                        iconBg="#16a34a"
                    />
                    <StatsCard
                        title="Total Balance"
                        icon={<WalletIcon size={20} color="#fff" />}
                        value={allAccountBalance}
                        iconBg="#2563eb"
                    />
                    <StatsCard
                        title="Total Trades"
                        icon={<ArrowsLeftRightIcon size={20} color="#fff" />}
                        value={total_trade}
                        iconBg="#7c3aed"
                    />
                </div>

                <ActiveTradingAccountList />
            </div>
        </SidebarLayout>
    );
};

export default TradingAccountMainPage;
